"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = reload;
function reload() {
  var isClient = typeof window !== 'undefined';
  if (!isClient) {
    return;
  }
  window.location.reload();
}